import {memo} from "react";
import { Dialog, Button, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import './ConfirmDialog.css'

export const ConfirmDialog = memo(({ title, children, open, setOpen, onConfirm, yesButtonLabel = 'Yes', noButtonLabel = 'No' }) => {

  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      aria-labelledby="confirm-dialog"
    >
      <DialogTitle id="confirm-dialog">{title}</DialogTitle>
      <DialogContent>{children}</DialogContent>
      <DialogActions>
        <Button
          variant="text"
          onClick={() => setOpen(false)}
        >
          {noButtonLabel}
        </Button>
        <Button
          variant="contained"
          onClick={() => {
            setOpen(false);
            onConfirm();
          }}
        >
          {yesButtonLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
});